import React from "react";
import Block from "@insightfulscience/atomic-react/Block";
import Link from "@insightfulscience/atomic-react/Link";

const AlertPreviewMode = () => (
	<Block
		utility={{ bgColor: "black" }}
		spacing={{ p: 4 }}
		style={{ position: "fixed", top: 0, right: 0, zIndex: 9999 }}
	>
		<Link
			href="/api/preview-disable"
			sx={{ fontColor: "white", hover: { fontColor: "black--15" } }}
		>
			Disable Preview Mode
		</Link>
	</Block>
);

export default AlertPreviewMode;
